import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { apiFetch } from '../lib/api-client';
import { useAuth } from '../store/auth';

export interface BriefTopic {
  label: string;
  focus: string;
}

export interface DailyBriefResponse {
  text: string | null;
  topics: BriefTopic[];
  freeRemaining: number;
  topicStars: number;
}

export function useDailyBrief(): {
  data: DailyBriefResponse | undefined;
  isLoading: boolean;
  isError: boolean;
} {
  const jwt = useAuth((s) => s.jwt);
  const { i18n } = useTranslation();
  const query = useQuery<DailyBriefResponse, Error>({
    queryKey: ['daily-brief', i18n.language],
    queryFn: async () => {
      if (!jwt) throw new Error('not_authenticated');
      const res = await apiFetch('/api/v1/me/daily-brief', jwt);
      if (!res.ok) {
        const body = await res.text().catch(() => '');
        throw new Error(`daily_brief_failed: ${res.status} ${body}`);
      }
      return (await res.json()) as DailyBriefResponse;
    },
    enabled: !!jwt,
    staleTime: 5 * 60_000,
  });
  return { data: query.data, isLoading: query.isLoading, isError: query.isError };
}
